// Basics
import * as React from 'react';
import { logout } from "../firebase";
import { useNavigate, useLocation, Link } from "react-router-dom";

// MUI
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Person from '@mui/icons-material/Person';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';


// Me
import dcLogoWhite from '../images/dcLogoWhite.png'

export default function ButtonAppBar({ accountDetails, themeMode, onToggleTheme }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const currentTab = location.pathname.startsWith('/dashboard/dco') ? 'dco' : 'jobs';

  const handleOpenModal = () => {
    setOpen(true);
  }

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <AppBar position="static" elevation={0} sx={{ boxShadow: 'none', borderBottom: 'none' }}>
      <Toolbar sx={{ justifyContent: 'space-between', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <img alt="" src={dcLogoWhite} style={{ maxHeight: 48 }}/>
          <Tabs
            value={currentTab}
            textColor="inherit"
            indicatorColor="primary"
            sx={{ minHeight: 48 }}
          >
            <Tab
              label="Jobs"
              value="jobs"
              component={Link}
              to="/dashboard/"
              sx={{ minHeight: 48 }}
            />
            <Tab
              label="DCO"
              value="dco"
              component={Link}
              to="/dashboard/dco"
              sx={{ minHeight: 48 }}
            />
          </Tabs>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title="Account">
            <IconButton onClick={handleOpenModal} color="inherit">
              <Person />
            </IconButton>
          </Tooltip>
          {/* <FormControlLabel
            control={<Switch checked={themeMode === 'dark'} onChange={onToggleTheme} color="default" />}
            label={themeMode === 'dark' ? 'Dark' : 'Light'}
          /> */}
          <Tooltip title="Log out">
            <IconButton color="inherit" onClick={logout}>
              <LogoutOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
      <div>
        <Dialog open={open} onClose={handleCloseModal}>
          <DialogTitle>Account</DialogTitle>
          <DialogContent>
            <div>Name: {accountDetails.name}</div>
            <div>Email: {accountDetails.email}</div>
            <div>Account(s): {accountDetails.accounts.join(',')}</div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    </AppBar>
  );
}
